import { Effect, Reducer } from 'umi';
import { overviewOriginType } from '../../types/performance';
import { getDetailBasicInfo } from '../../services/intelligence';

const namespace = 'intelligence';

type stateType = {
  [key: string]: any;
};

const customModel: {
  effects: {
    [key: string]: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    keyword: [],
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *getDetailBasicInfo({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getDetailBasicInfo({
          ...payload,
        });
        // console.log('channel111', res);

        yield put({
          type: 'save',
          payload: {
            baseInfo: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keyMetrics: [],
          },
        });
      }
    },
  },
};

export default customModel;
